import type { Subscription } from '../../types';
import { canMakeSelfServeChanges as canMakeLegacySubscriptionSelfServeChanges } from '../legacySubscription';
import { canMakeSelfServeChanges as canMakeModernSubscriptionSelfServeChanges } from '../modernSubscription';

import { isModernSubscription } from './isModernSubscription';

export function canMakeSelfServeChanges(subscription: Subscription) {
  if (isModernSubscription(subscription)) {
    return canMakeModernSubscriptionSelfServeChanges(subscription);
  }

  return canMakeLegacySubscriptionSelfServeChanges(subscription);
}
